import { Draw, East } from '@mui/icons-material';
import {
  Button,
  Chip,
  IconButton,
  Skeleton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Label from 'src/components/Label';
import SignAllIcon from 'src/icons/untitled-ui/duocolor/sign-all-icon';

type Props = {
  item?: any;
  handleNavigateToMonthEndAlert: any;
  handleClickOpen: any;
};

const MonthEndAlertTable = (props: Props) => {
  const { item = [], handleNavigateToMonthEndAlert, handleClickOpen } = props;

  const monthCloseOutResponse = useSelector((state: any) => state.monthlyCloseOutAlertReducer);
  return (
    <Box sx={{ position: 'relative' }}>
      <Table sx={{ minWidth: 700 }}>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Cycle Date </TableCell>
            <TableCell>Number of Alerts</TableCell>
            <TableCell>Closeout Status</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {monthCloseOutResponse?.loading ? (
            <>
              <TableRow>
                <TableCell colSpan={6}>
                  <Box
                    textAlign="center"
                    p={4}
                  >
                    {}{' '}
                    {['1', '2', '3', '4', '5', '6']?.map((res) => {
                      return (
                        <Typography
                          key={res}
                          variant="h4"
                        >
                          <Skeleton animation="wave" />
                        </Typography>
                      );
                    })}
                  </Box>
                </TableCell>
              </TableRow>
            </>
          ) : item?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6}>
                <Box
                  textAlign="center"
                  p={3}
                >
                  <Typography
                    color={'text.secondary'}
                    variant="subtitle2"
                  >
                    No Records Found
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            item?.map((res: any, index: any) => {
              return (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{`${moment(res?.range?.startDate).format('MMM D, YYYY')} - ${moment(
                    res?.range?.endDate
                  ).format('MMM D, YYYY')}`}</TableCell>
                  <TableCell>
                    {res?.errors == 0 && res?.warnings == 0 && res?.ignores == 0 ? (
                      <>No alerts</>
                    ) : (
                      <>
                        {`${res?.errors} Errors | ${res?.warnings} Warnings | ${res?.ignores} Ignores`}
                      </>
                    )}
                  </TableCell>
                  <TableCell>
                    {res?.status === 'OPEN' ? (
                      <Label
                        backgroundColor="#F044381F"
                        color="#B42318"
                        text={res?.status}
                      />
                    ) : res?.status === 'CLOSED' ? (
                      <Label
                        backgroundColor="#EBEEFE"
                        color="#6366F1"
                        text={res?.status}
                      />
                    ) : (
                      <Label
                        backgroundColor="#15B79E1F"
                        color="#107569"
                        text={res?.status?.split('_')?.join(' ')?.replace('AND', '&')}
                      />
                    )}
                  </TableCell>
                  <TableCell align="right">
                    {res?.status === 'CLOSED' ? (
                      <Button
                        sx={{
                          height: '30px',
                        }}
                        size="small"
                        startIcon={
                          <SvgIcon>
                            <SignAllIcon />
                          </SvgIcon>
                        }
                        variant="contained"
                        onClick={() => handleClickOpen(res)}
                      >
                        <Typography variant="buttonText">Sign All</Typography>
                      </Button>
                    ) : null}
                    <IconButton onClick={() => handleNavigateToMonthEndAlert(res?.range)}>
                      <East />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default MonthEndAlertTable;
